import React, { useEffect, useReducer, useRef } from 'react';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import Search from '../search/search';
import PropTypes from 'prop-types';
import { VALID_ADDRESS_FIELDS, getAddressData } from '../../utils/templates/address';
import { change, Field, untouch } from 'redux-form';
import RenderTextField from '../form-controls/RenderTextField';
import RenderCommonDropdownField from '../form-controls/RenderCommonDropdownField';
import { connect } from 'react-redux';
import { DETAIL_HANDLER, normalizeSG, SUGGESTION_HANDLER } from './hooks';
import { resetFields, checkAllEmptyArrayValues } from '../../utils/library';
import { EU_EXCEPTIONS_COUNTRIES, EU_REGION } from '../../utils/constants';
import { required } from '../../utils/validation/index';
import { API_URL } from '../../utils/config';
import { setAddressInfo, setAddressError } from '../../redux/actions/user-state/user-state-action';
import {
  setShowSearchBoxVisibilty,
  resetSearchBoxDetails,
  setRequiredFields,
  setSearchText
} from '../../redux/actions/common/common-action';
import './address-block.css';
import isEqual from 'lodash/isEqual';
const reducer = (state, action) => ({ ...state, ...action });

function AddressBlock(props) {
  const [state, setState] = useReducer(reducer, {
    suggestions: [],
    fields: [],
    totalPages: 1,
    page: 1,
    requiredFieldName: [],
    loading: false,
    disable_fields: true,
    showMessage: false,
    showFields: !(
      !EU_REGION.includes(props.countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(props.countryCode)
    ),
    selectedData: ''
  });
  const { isSsnBackNavigatedFlag } = props;
  useEffect(() => {
    const { countryCode, dispatch } = props;
    dispatch(resetSearchBoxDetails());
    let showSearchBox =
      !EU_REGION.includes(countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(countryCode);
    dispatch(setShowSearchBoxVisibilty(showSearchBox));
    setState({
      fields: getAddressData(props.addressConfig)
    });
    /**
     * find all validate required state and check
     * for there redux value if its not null then
     * send a true flag to **not show** 'Please enter valid address '
     * this message else need to show this message
     */

    const requiredFields = state.fields.filter(
      (item) => item.validate && item.validate.includes(required)
    );
    const requiredFieldName = requiredFields.map((f) => f.field);

    props.dispatch(setRequiredFields(requiredFieldName));

    const { getAllformVal } = props;
    if (getAllformVal) {
      const reqAddrFields = Object.keys(VALID_ADDRESS_FIELDS);
      Object.keys(getAllformVal).forEach((x) => {
        if (!state.showFields && reqAddrFields.includes(x) && getAllformVal[x]) {
          setState({ showFields: true });
        }
      });
    }
    return () => {
      props.dispatch(setAddressError(null));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { getAllformVal, formSectionName } = props;
    /**
     * check for change in value for address.
     * Also check for corporate address by form section
     *
     */

    if (!isEqual(prevFields.current, getAllformVal)) {
      const reqAddrFields = Object.keys(VALID_ADDRESS_FIELDS);

      // to check if address in business and incorporation has all empty string
      const formSectionValues =
        formSectionName &&
        getAllformVal &&
        getAllformVal[formSectionName] &&
        Object.values(getAllformVal[formSectionName]);
      const isFormSectionAllEmpty = checkAllEmptyArrayValues(formSectionValues);
      getAllformVal &&
        Object.keys(getAllformVal).forEach((x) => {
          if (!state.showFields && reqAddrFields.includes(x) && getAllformVal[x]) {
            /**if corp && formSection empty hide form fields else show fields */
            if (formSectionName && getAllformVal[formSectionName] && isFormSectionAllEmpty) {
              setState({ showFields: false });
            } else {
              setState({ showFields: true });
            }
          }
        });
    }
  });
  const prevFields = useRef;

  useEffect(() => {
    const { getAllformVal } = props;
    prevFields.current = getAllformVal;
  });

  useEffect(() => {
    if (props.countryCode) {
      state.fields.forEach(({ field }) => props.dispatch(change(props.formName, field, '')));
    }

    setState({
      fields: getAddressData(props.addressConfig),
      suggestions: []
    });
    setSearch && setSearch('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.countryCode]);

  useEffect(() => {
    setState({
      fields: getAddressData(props.addressConfig)
    });
  }, [props.addressConfig]);

  useEffect(() => {
    /**if search node is mount and (textFieldRef || dropdownRef ) is not mount the show error on submit */
    const searchAddressFieldNotSelected =
      searchRef.current && !(textFieldRef.current || dropdownRef.current);
    if (searchAddressFieldNotSelected) {
      props.dispatch(setAddressError('Please Select Address from search'));
    } else {
      props.dispatch(setAddressError(null));
    }
  });

  let setSearch = '';
  const searchRef = useRef(null);
  const dropdownRef = useRef(null);
  const textFieldRef = useRef(null);

  useEffect(() => {
    const searchAddressFieldNotSelected =
      searchRef.current && (textFieldRef.current || dropdownRef.current);
    if (searchAddressFieldNotSelected) {
      props.dispatch(setAddressError(null));
    }
  });

  /**reset form fields to null */
  const resetFormFields = (fields, dispatch) => {
    const fieldObj = fields.reduce((acc, res) => {
      acc[res.field] = '';
      return acc;
    }, {});
    resetFields(
      props.formName,
      fieldObj,
      dispatch,
      change,
      untouch,
      props.formSectionName ? props.formSectionName : null
    );
  };

  const onSearchChangeGenerator = (country_code) => {
    const { dispatch } = props;
    let { [country_code]: handler = SUGGESTION_HANDLER.default } = SUGGESTION_HANDLER;
    return async (keyword = '', page, refresh = true, search_id) => {
      resetFormFields(state.fields, dispatch);
      await setState({ loading: true, showFields: false });
      let params = {
        keyword,
        country_code,
        page: refresh ? 1 : page
      };
      if (search_id) params.search_id = search_id;
      let result = await handler(params, !refresh && state.suggestions);
      if (result) {
        // dispatch and store disabled_fields in redux
        const { disable_fields } = result;
        const { dispatch } = props;
        dispatch(
          setAddressInfo({
            disable_fields
          })
        );
      }
      await setState({
        loading: false,
        disable_fields: (result && result.disable_fields) || false,
        showMessage: (result && !result.disable_fields) || false,
        ...(result || (result === undefined ? { suggestions: [] } : {}))
      });
    };
  };
  const toggleShowFields = () => {
    setState({ showFields: false });
    resetFormFields(state.fields, props.dispatch);
  };
  const onSuggestionSelectedGenerator = (country_code) => {
    return async (optn) => {
      let { value, Id: placeId } = optn;
      // eslint-disable-next-line
      if (typeof placeId == 'string' ? !placeId : value < 0 || value >= state.suggestions.length)
        return;
      setState({ loading: true });
      let data = await DETAIL_HANDLER[country_code](
        {
          placeId: value,
          country_code
        },
        state.suggestions
      );
      if (data) {
        let { fields } = state,
          { formName, formSectionName, dispatch } = props;
        await fields.forEach(({ field }) =>
          dispatch(
            change(
              formName,
              formSectionName ? `${formSectionName}.${field}` : field,
              field === 'street'
                ? data['street_name'] || data['street_type']
                  ? (data['street_name'] || '') + ' ' + (data['street_type'] || '')
                  : ''
                : data[field]
            )
          )
        );
      }
      await setState({
        loading: false,
        keepOpen: false,
        selectedData: data,
        showFields: true
      });
    };
  };

  const isDisabled = (field, shouldDisable, disable_fields) => {
    let currentField = field.field;
    const { selectedData } = state;
    if (selectedData) {
      if (currentField === 'street' && !selectedData.street_name && !selectedData.street_type) {
        return false;
      } else if (currentField !== 'street' && !selectedData[currentField]) {
        //street
        return false;
      }
    }

    // eslint-disable-next-line no-prototype-builtins
    let responseOfDisabled = field.hasOwnProperty('editable')
      ? disable_fields
        ? !field.editable
        : false
      : false;
    return responseOfDisabled || props.isDocsUploadedOrEVerifiedSuccess || shouldDisable;
  };

  let {
    countryCode,
    sectionHead,
    isDocsUploadedOrEVerifiedSuccess,
    onCountryOfResidenceChange,
    renderCountryOfResidence,
    disabledFields,
    getAllformVal,
    mailingAddress,
    newSearchUi,
    iconPlacement
  } = props;
  let { totalPages, page, suggestions, loading, disable_fields, showMessage } = state;

  let shouldDisable = false;
  if (disabledFields) {
    shouldDisable = state && state.fields && state.fields.find((k) => k && disabledFields[k.field]);
  }

  const onSearchChange = (args) => {
    setState({ showFields: false });
    args && onSearchChangeGenerator(countryCode)(args);
  };

  return (
    <Grid.Row className="form-row" id="address-block">
      <Grid.Column className="payee-details-column" width={16}>
        <div className="form-flow-header">
          {sectionHead
            ? sectionHead
            : countryCode === 'MY'
            ? mailingAddress
              ? 'Mailing address'
              : 'Residential address'
            : 'Address'}
        </div>
      </Grid.Column>
      {renderCountryOfResidence && (
        <Grid.Column width={16}>
          <Field
            bindToThisObject={countryCode}
            name="country_code"
            type="text"
            component={RenderCommonDropdownField}
            placeholder="Country of residence"
            onDropdownClose={onCountryOfResidenceChange}
            selectOnClose={true}
            validate={[required]}
            className="theme-dropdown"
            onDropdownChange={async (countryObj) => {
              const { value } = countryObj;
              props.dispatch(setSearchText(''));

              await setState({ showFields: false, showMessage: false });

              let showSearchBox =
                !EU_REGION.includes(value) || EU_EXCEPTIONS_COUNTRIES.includes(value);
              let _showFields = !showSearchBox ? true : false;
              props.dispatch(setShowSearchBoxVisibilty(showSearchBox));
              await setState({ showFields: _showFields });
            }}
            url={`${API_URL}/beneficiary/countries/dropdown`}
          />
        </Grid.Column>
      )}
      <Grid.Column width={16} className="search-bar-wrapper">
        {(!EU_REGION.includes(countryCode) || EU_EXCEPTIONS_COUNTRIES.includes(countryCode)) && (
          <Search
            iconPlacement={iconPlacement}
            newSearchUi={newSearchUi}
            toggleShowFields={toggleShowFields}
            showFields={state.showFields}
            ref={searchRef}
            placeholder={
              countryCode === 'SG'
                ? 'Type in your postal code'
                : EU_EXCEPTIONS_COUNTRIES.includes(countryCode)
                ? 'Start typing address/postal code here'
                : ['US'].includes(countryCode)
                ? 'Start searching with street number'
                : 'Start typing address here'
            }
            countryCode={props.countryCode}
            disabled={
              !countryCode ||
              isDocsUploadedOrEVerifiedSuccess ||
              shouldDisable ||
              isSsnBackNavigatedFlag
            }
            onSearchChange={onSearchChange}
            onSuggestionSelect={(...arg) => {
              onSuggestionSelectedGenerator(countryCode)(...arg);
            }}
            suggestions={suggestions}
            totalPages={totalPages}
            page={page}
            renderSuggestion={({ key, title }) => (
              <div className="suggestion" key={key}>
                {title}
              </div>
            )}
            setSearchValueProvider={(func) =>
              (setSearch = function (value) {
                setState({ totalPages: 1, page: 1 });
                func(value);
              })
            }
            keepOpen={state.keepOpen}
            onBlur={() => setState({ loading: false })}
            loading={loading}
            normalization={countryCode === 'SG' ? normalizeSG : null}
          />
        )}
      </Grid.Column>
      {showMessage && (
        <div style={{ padding: '1rem', color: 'red' }}>
          Looks like we are not able to pull your address automatically. Please proceed by filling
          your address manually.
        </div>
      )}
      <div className="address-fields-wrapper">
        {state.showMessage || state.showFields
          ? state.fields.map((field, key) => {
              if (!field.visible) {
                return null;
              }
              switch (field.type) {
                case 'text': {
                  return (
                    <Grid.Column
                      computer={7}
                      tablet={8}
                      mobile={16}
                      key={key}
                      style={field.parentStyle || null}
                    >
                      <Field
                        ref={textFieldRef}
                        name={field.field}
                        type="text"
                        className="input form-flow"
                        component={RenderTextField}
                        validate={shouldDisable ? null : field.validate}
                        normalize={field.normalize}
                        placeholder={field.placeholder}
                        disabled={
                          isDisabled(field, shouldDisable, disable_fields) || isSsnBackNavigatedFlag
                        }
                        tooltip={getAllformVal && !getAllformVal[field.field] && field.tooltip}
                      />
                    </Grid.Column>
                  );
                }
                case 'dropdown': {
                  return (
                    <Grid.Column computer={7} tablet={8} mobile={16} key={key}>
                      <Field
                        bindToThisObject={getAllformVal ? getAllformVal[field.field] : null}
                        name={field.field}
                        type="text"
                        ref={dropdownRef}
                        component={RenderCommonDropdownField}
                        className="theme-dropdown"
                        url={`${field.url}`}
                        validate={shouldDisable ? null : field.validate}
                        normalize={field.normalize}
                        placeholder={field.placeholder}
                        disabled={
                          isDisabled(field, shouldDisable, disable_fields) || isSsnBackNavigatedFlag
                        }
                      />
                    </Grid.Column>
                  );
                }
                default:
                  return null;
              }
            })
          : null}
      </div>
    </Grid.Row>
  );
}

AddressBlock.propTypes = {
  transactionDetails: PropTypes.object,
  getAllformVal: PropTypes.any,
  isDocsUploadedOrEVerifiedSuccess: PropTypes.bool,
  countryCode: PropTypes.any,
  parent: PropTypes.any,
  sectionHead: PropTypes.string,
  formSectionName: PropTypes.string,
  formName: PropTypes.string,
  dispatch: PropTypes.func,
  countryCodeUrl: PropTypes.string,
  onCountryOfResidenceChange: PropTypes.func,
  renderCountryOfResidence: PropTypes.bool,
  disabledFields: PropTypes.any,
  addressField: PropTypes.array,
  addressConfig: PropTypes.any,
  account_type: PropTypes.string,
  mailingAddress: PropTypes.bool,
  iconPlacement: PropTypes.string,
  newSearchUi: PropTypes.bool,
  isSsnBackNavigatedFlag: PropTypes.bool
};

export default connect(null, (dispatch) => ({ dispatch }))(AddressBlock);
